export enum AnalyzeState {
  NEW = 'new',
  UNLOCKING = 'unlocking',
  UNLOCKED = 'unlocked',
  ANALYZING = 'analyzing',
  READY = 'ready',
  ERROR = 'error',
}
